<script lang="ts">
    import { smartRounding } from '../components/telematics/tools/smartRounding';
    import { _ } from 'svelte-i18n';

    export let seconds: number | null = null;
    export let displayFormat: 'duration' | 'time' = 'duration';
    export let showSign: boolean = false;
    export let prefix: string = '';

    let formatted: { sign: string; hours: string; minutes: string; separator: string } = {
        sign: '',
        hours: '',
        minutes: '',
        separator: '',
    };

    let formattedTime = function (seconds: number, showSign: boolean = false): any {
        let minutes = Math.floor(Math.abs(seconds) / 60);
        let hours = Math.floor(minutes / 60);
        minutes = minutes % 60;

        let smartHours = new smartRounding().getRoundedValues(hours, '', { convert_nicer: true });
        switch (displayFormat) {
            case 'duration':
                return {
                    sign: seconds < 0 ? '-' : showSign ? '+' : '',
                    hours: [smartHours.rounded_value, smartHours.rounded_title].join(''),
                    minutes: minutes.toString().padStart(2, '0'),
                    separator: 'h',
                };
            case 'time':
                return {
                    sign: seconds < 0 ? '-' : showSign ? '+' : '',
                    hours: [smartHours.rounded_value, smartHours.rounded_title].join(''),
                    minutes: minutes.toString().padStart(2, '0'),
                    separator: ':',
                };
        }
    };

    $: if (seconds !== null) formatted = formattedTime(seconds, showSign);
</script>

{#if displayFormat === 'duration'}
    <div class="dont-break time-formatter duration">
        {#if formatted.hours === '0'}
            {prefix}{formatted.sign}
            {parseInt(formatted.minutes)}
            <div class="time-separator time-separator-duration" style="margin-left: 3px">{$_('min')}</div>
        {:else}
            {prefix}{formatted.sign}{formatted.hours}
            <div class="time-separator time-separator-duration">{formatted.separator}</div>
            {#if seconds !== null && seconds < 3600 * 24}
                {formatted.minutes}
            {/if}
        {/if}
    </div>
{:else}
    <div class="dont-break time-formatter time">
        {prefix}{formatted.sign}{formatted.hours}
        <div class="time-separator time-separator-time">{formatted.separator}</div>
        {formatted.minutes}
    </div>
{/if}

<style>
    .time-formatter {
        display: flex;
        flex-direction: row;
        align-items: baseline;
        justify-content: flex-end;
    }
    .time-separator {
        font-size: 0.7rem;
        opacity: 0.5;
    }
    .time-separator-duration {
        font-weight: 300;
        opacity: 0.6;
        margin: 0 3px 0 1px;
    }
    .time-separator-time {
        font-weight: 600;
        margin: 0 1px 0 1px;
    }
</style>
